import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { selectTeamSelectedChannels } from "@/selectors";
import { RootState } from "@/utils/store";

const useChannelsFilter = (): [number[], string] => {
  const { teamId } = useParams();

  const filteredChannelsIds = useSelector((rootState: RootState) =>
    selectTeamSelectedChannels(rootState, teamId!)
  );

  const keyForCache = filteredChannelsIds.join("-");

  return [filteredChannelsIds, keyForCache];
};

export default useChannelsFilter;
